import { NavLink, Outlet } from "react-router-dom";
import { getUserInfo, isPlatformAdmin, logout } from "../lib/auth";
import { NewVersionBanner } from "./NewVersionBanner";
import { useOpenIdentityConflictsCount } from "../hooks/use-open-identity-conflicts-count";

const NAV_ITEMS = [
  { to: "/conversations", label: "Conversations" },
  { to: "/dealers", label: "Dealers" },
  { to: "/support", label: "Support Queue" },
  { to: "/identity-conflicts", label: "Identity Conflicts" },
  { to: "/review", label: "Review Queue" },
  { to: "/outbid-engagement", label: "Outbid Engagement" },
  { to: "/tb360-bid-engagement", label: "TB360 Bid Engagement" },
  { to: "/observability", label: "Observability" },
  { to: "/recommend", label: "Recommend Vehicle" },
];

const ADMIN_NAV_ITEMS = [{ to: "/platform-admin", label: "Platform Admin" }];

function NavBadge({ count }: { count: number }) {
  return (
    <span
      style={{
        marginLeft: "auto",
        padding: "1px 8px",
        borderRadius: 10,
        fontSize: 11,
        fontWeight: 600,
        background: "var(--color-warning)",
        color: "#1a1300",
        minWidth: 18,
        textAlign: "center",
      }}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}

export function AppShell() {
  const user = getUserInfo();
  const openConflictsCount = useOpenIdentityConflictsCount();

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-header">
          <img src="/assets/logo.png" alt="Otto" />
          <span>Otto</span>
        </div>
        <nav>
          {NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => (isActive ? "active" : "")}
              style={{ display: "flex", alignItems: "center" }}
            >
              <span>{item.label}</span>
              {item.to === "/identity-conflicts" &&
                openConflictsCount !== null &&
                openConflictsCount > 0 && <NavBadge count={openConflictsCount} />}
            </NavLink>
          ))}
          {isPlatformAdmin() && (
            <>
              <hr className="sidebar-nav-divider" />
              {ADMIN_NAV_ITEMS.map((item) => (
                <NavLink key={item.to} to={item.to} className={({ isActive }) => (isActive ? "active" : "")}>
                  {item.label}
                </NavLink>
              ))}
            </>
          )}
        </nav>
        <div className="sidebar-footer">
          {user && <div>{user.givenName} {user.familyName}</div>}
          {user && <div style={{ marginBottom: 8 }}>{user.email}</div>}
          <button type="button" onClick={logout}>
            Sign out
          </button>
        </div>
      </aside>
      <main className="main-content">
        <NewVersionBanner />
        <Outlet />
      </main>
    </div>
  );
}
